"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useContext } from "react";
import { PencilIcon } from "@heroicons/react/24/outline";
import type { ApiDrop } from "@/generated/models/ApiDrop";
import { AuthContext } from "@/components/auth/Auth";
interface WaveDropMobileMenuEditProps {
  readonly drop: ApiDrop;
  readonly onEdit: () => void;
  readonly onEditTriggered: () => void;
}
const WaveDropMobileMenuEdit: React.FC<WaveDropMobileMenuEditProps> = t0 => {
  const $ = _c(7);
  const {
    drop,
    onEdit,
    onEditTriggered
  } = t0;
  const {
    connectedProfile
  } = useContext(AuthContext);
  if (connectedProfile?.handle !== drop.author.handle) {
    return null;
  }
  let t1;
  if ($[0] !== onEdit || $[1] !== onEditTriggered) {
    t1 = () => {
      onEdit();
      onEditTriggered();
    };
    $[0] = onEdit;
    $[1] = onEditTriggered;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const handleEdit = t1;
  let t2;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <PencilIcon className="tw-flex-shrink-0 tw-w-5 tw-h-5 tw-text-iron-300" />;
    t3 = <span className="tw-text-iron-300 tw-font-semibold tw-text-base">Edit Message</span>;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  let t4;
  if ($[5] !== handleEdit) {
    t4 = <button className="tw-border-0 tw-flex tw-items-center tw-gap-x-4 tw-p-4 tw-bg-iron-950 tw-rounded-xl active:tw-bg-iron-800 tw-transition-colors tw-duration-200" onClick={handleEdit}>{t2}{t3}</button>;
    $[5] = handleEdit;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
};
export default WaveDropMobileMenuEdit;